import type { FeedRow } from "../types";
import type {
  FeedEvent,
  FeedSubmission,
  FeedPolicyVersion,
} from "./feed-records";
import { eventRow, submissionRow } from "./feed-rows";
const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
export const maxActivityRows = 8;
export function buildFeed({
  events,
  submissions,
  policyVersions,
  policyName,
  now,
}: {
  readonly events: readonly FeedEvent[];
  readonly submissions: readonly FeedSubmission[];
  readonly policyVersions: readonly FeedPolicyVersion[];
  readonly policyName: string | null;
  readonly now: string;
}): FeedRow[] {
  const nowMs = Date.parse(now);
  const cutoff = nowMs - sevenDaysMs;
  const inWindow = (iso: string): boolean => {
    const at = Date.parse(iso);
    return !Number.isNaN(at) && at >= cutoff && at <= nowMs;
  };
  const rows: (FeedRow | null)[] = [
    ...events.map((event) => eventRow({ event, policyName })),
    ...submissions.map((submission) =>
      submissionRow({ submission, policyName }),
    ),
    ...policyVersions
      .filter((version) => version.policy_name === policyName)
      .map((version): FeedRow => ({
        notice: "upload",
        at: version.created_at,
        policyLabel: `${version.policy_name}:v${version.version}`,
        text: "uploaded",
        champion: false,
        href: null,
      })),
  ];
  return rows
    .filter((row): row is FeedRow => row !== null && inWindow(row.at))
    .toSorted((a, b) => Date.parse(b.at) - Date.parse(a.at));
}
